import { useEffect } from 'react'

/**
 * Locks body scroll while `isLocked` is true, matching Bootstrap Modal behaviour:
 * - Sets overflow: hidden on <body>
 * - Adds padding-right equal to the scrollbar width to prevent layout shift
 * Restores both on cleanup.
 */
export function useScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.overflow = 'hidden'
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`
    }

    return () => {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }
  }, [isLocked])
}
